export const workflowReport = {
  workflow_report: "Workflow Report",
  workflow_name: "Workflow name",
  approvers: "Approvers",
  review_allowed: "Review allowed",
  disable_approval: "Disable approval",
  created_on: "Created On",
  total_pending_approval_docs: "Total pending approval docs",
  total_approved_docs: "Total approved docs",
  total_rejected_docs: "Total rejected docs",
  total_workflow: "Total workflow",
  most_executed_workflows: "Most wxecuted workflows",
  most_executed_workflow_approved_by: "Most executed workflow approved by",
  most_executed_workflow_rejected_by: "Most executed workflow rejected by",
  most_executed_workflow: "Most executed workflow",
  most_executed_workflow_count: "Most executed workflow count",
  approved_by: "Approved by",
  rejected_by: "Rejected by",
  overview: "Overview",
  approver_email: "Approver email",
  total_executions: "Total executions",
  total_pending_approval: "Total pending approval",
  total_approved: "Total approved",
  total_rejected: "Total rejected",
  workflow_createdOn: "Workflow created on",
  last_updated: "Last updated",
  most_workflow_approved_by: "Most workflow approved by",
  most_workflow_rejected_by: "Most workflow rejected by",
  is_runtime: "Runtime",
  is_active: "Active",
  is_review_document: "Review Allowed",
  workflow_approval_status: "Workflow approval status",
  number_of_documents: "Number of documents",
  no_data_available: "No data available",
  total: "Total",
  document_uploaded_in_portal: "Document uploaded in portal",
  document_integrated_into_output_data: "Document integrated into output data",
  pending_integration: "Pending integration",
  processed_and_reviewed: "Processed and reviewed",
  documents_in_failed_status: "Documents in failed status",
  documents_in_processed_and_reviewed_status:
    "Documents in processed and reviewed status",
  document_usage_report: "Document Usage Report",
  document_in_need_review_status: "Document in need review status",
  document_count: "Document count",
  "Manual view": "Manual view",
  "Email view": "Email view",
  "Sent to ERP": "Sent to ERP",
  "Not sent to ERP": "Not sent to ERP",
  "Need review": "Need review",
  "Other documents": "Other documents",
  "Total documents": "Total documents",
  "Failed documents": "Failed documents",
  "Pending integration": "Pending integration",
  "Processed and reviewed": "Processed and reviewed",
  "Workflow name": "Workflow name",
  "Start date is required": "Start date is required",
  "End date is required": "End date is required",
  "End date cannot be before start date":
    "End date cannot be before start date",
  "Start date cannot be in the future": "Start date cannot be in the future",
  "End date cannot be in the future": "End date cannot be in the future",
  User: "User",
  "Customer ID": "Customer ID",
  analytics: "Analytics",
  "Yearly Amount": "Yearly amount",
  "Monthly Amount Trend": "Monthly amount trend",
  "Paid vs Unpaid Invoices": "Paid vs unpaid invoices",
  "Category Distribution": "Category distribution",
  "Vendor Distribution": "Vendor distribution",
  "Document Type distribution": "Document type distribution",
  "Vendor-Level Sankey Flow": "Vendor-level sankey flow",

  TotalAmount: "Total amount",
  AccountPayable: "Account payable",
  AccountReceivable: "Account receivable",
  Invoice: "Invoice",
  DeliveryNote: "Delivery note",
  PurchaseOrder: "Purchase order",
  Expense: "Expense",
  Stockable: "Stockable",
  Investment: "Investment",
  Inventory: "Inventory",
  Other: "Other",
  yearly_amount: "Yearly amount",
  Year: "Year",
  Month: "Month",
  OverDue: "Over due",
  document_type_distribution: "Document type distribution",
  monthly_amount_trend: "Monthly amount trend",
  failed_to_fetch_chart_data: "Failed to fetch data",
  "UnSpecified Vendors": "Unspecified vendors",
  monthly_document_summary: "Monthly document summary",
  Uploaded: "Uploaded",
  uploaded: "Uploaded",
  success_integrated: "Success integrated",
  fail_integrated: "Fail integrated",
  year_wise_document_summary: "Year wise document summary",
  "Document Summary Table": "Document summary table",
  "Document Summary": "Document summary",
  "Add Report": "Add report",
  "Add a new custom report": "Add a new custom report",
  "Report name": "Report name",
  Cancel: "Cancel",
  "Report name is required": "Report name is required",
  "Failed to add report": "Failed to add report",
  "Edit custom report": "Edit custom report",
  "Save Report": "Save report",
  workflow_approvers: `Workflow approvers`,
  workflow_approvers_with_value: `Workflow approvers: {{value}}`,
  workflow_approval_status_by_workflow_name: `Approval status by workflow`,
  workflow_approval_status_by_approvers: `Approval status by approvers`,
  document_approval_summary_report: "Document approval summary report",
  start_date: "Start date",
  end_date: "End date",
  download: "Download",
  start_date_required: "Start date is required",
  end_date_required: "End date is required",
  csv_downloaded_successfully: "CSV downloaded successfully",
  failed_to_download_csv: "Failed to download CSV",
};
